import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  Inject,
  NgZone,
} from '@angular/core';
import { MyModule } from './model/my-module';
import { SubModule } from './model/sub-module';
import { SubSubModule } from './model/sub-sub-module';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Router, NavigationEnd, Event, ActivatedRoute, NavigationStart } from '@angular/router';
import { MainContainerService } from './service/main-container.service';
import { PageUrl } from './common/page-url';
import { Icon } from 'src/app/icon';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
} from '@angular/forms';
import { UserLogInDetail } from './model/user-log-in-detail';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { OktaCustomAPIService } from './service/okta-custom-api.service';
import { ToastService } from './service/toast.service';
import { ChooseLocationDialogComponent } from './common/choose-location-dialog/choose-location-dialog.component';
import { PageBinding } from './common/page-binding';
// import { isThisQuarter } from 'date-fns';
// import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
// import { Location } from './model/location';
import { Constant } from './common/constant';
import { CommonService } from './service/Security/common.service';
// import { tr } from 'date-fns/locale';
import { FCMMessageRegistration } from './model/Others/FCMMessageRegistration';
import { FCMMessageResponse } from './model/Others/FCMMessageResponse';

import { APIFactoryEndPoints } from './common/apifactory-end-points';
// import { AngularFireMessaging } from '@angular/fire/messaging';
import { environment } from 'src/environments/environment';
import { ConfirmationDialogComponent } from './common/ConfirmationDialog/confirmation-dialog/confirmation-dialog.component';
import { PosService } from './service/Sale/POS/pos.service';
import { DatePipe, LocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';
import { AuthorisationCreateViewEditCancel } from './common/authorisationCreateViewEditCancel';
//import { Idle, DEFAULT_INTERRUPTSOURCES, LocalStorage } from '@ng-idle/core';
// import { Keepalive } from '@ng-idle/keepalive';

import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { getWindow } from 'ssr-window';
import { LocalStorageService } from './common/LocalStorageService';
import { Customer } from './model/Master/Customer/customer';
import { HttpErrorResponse } from '@angular/common/http';
import moment from 'moment';
import { ErrorLog } from './model/Common/error-log';
import { AllModule } from './model/AllModule';
import { DigitalClockComponent } from './common/digitalClock/digital-clock/digital-clock.component';
import { DateAdapter } from '@angular/material/core';
// import { OktaAuth } from '@okta/okta-auth-js';
// import { OKTA_AUTH } from '@okta/okta-angular';

import CryptoJS from 'crypto-js';
// import { stringToBase64Url } from '@okta/okta-auth-js/types/lib/crypto';
import { Location } from '@angular/common';
import * as spawn from 'child_process';
import { logOutApp, StopPlayingMusic } from 'src/myfunc';
import { JwtService } from './common/jwt.service';
import { JwtDecodeService } from './common/login/others/JWTDecodeService';
import { ThemeService } from './service/theme.service';
import { IdleService } from './common/IdleService';
import { IdleWarningDialogComponent } from './common/idle-dialog/IdleWarningDialog';
import { AppConfigService } from './service/Configuration/app-config.service';
import { initializeApp } from "firebase/app";
import { Key } from 'readline';
import { KeyboardShortcutService } from './common/KeyBoardService';
import { MessagingService } from './service/MessageService/messaging.service';
import { CustomOverlayPositionService } from './core/custom-overlay-position.service';
import { Overlay } from '@angular/cdk/overlay';
import { MastercontainerService } from './service/Master/mastercontainer.service';
import { Internationalization } from './model/Master/internationalization';
import { RequestView } from './model/requestview';
import { WebOrderService } from './service/WebOrder/web-order.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { PendingOrdersBottomSheetComponent } from './Module/Shipping/Shippings/pending-orders-bottom-sheet/pending-orders-bottom-sheet.component';
import { DeviceDetectorService } from './common/device-detector.service';
import { MasterfunctionService } from './service/Master/masterfunction.service';
const {
  textToSpeechAnd,
  qrCodeData,
  appUpdateForDevice,
  setUserIdFromApp,
  StopMessageAndBeep,
} = require('src/myfunc.js');
// 1. Tell TypeScript to treat 'google' as 'any' to bypass strict interface checks
declare var google: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})

export class AppComponent implements OnInit {
  @ViewChild('menu') menu: ElementRef;
  confirmDialogOpen: boolean = false;
  idleState = 'Not started.';
  manageBeepAndTextList: string;
  message: string = '';
  timedOut = false;
  lastPing?: Date = null;
  isLoading: boolean = false;
  reverseSubSubMenuService: Subscription;
  hideMatBadge: boolean = true;
  viewContent: boolean;
  allowPageNavigation: boolean = true;
  enableDisableFCMMonitoring: string = '';
  enableDisableFCMMonitoringLastUsed: string = '';
  ///////////////////////////////////
  history: string[] = [];
  currentPos: number = 0;
  getUniqueID: string = '';
  payL: any = '';
  nos: number = 0;
  DeviceID: string;
  fCMMessageRegistration: FCMMessageRegistration = new FCMMessageRegistration();
  fCMMessageResponse: FCMMessageResponse[] = [];
  currentMessage = new BehaviorSubject(this.payL);

  fcmResponse: any;

  inLoginPage: boolean = false;
  ///////////////////////////
  title = 'AssetManager';
  noofFCMMessages: number;
  data: string = '';
  menuLevel: number = 0;
  manageMenuLevel: number = 0;
  constant: Constant = new Constant();
  isShow = false;
  step: string = 'left';
  isAuthenticated: boolean = false;
  public show: boolean = false;
  modules: MyModule[] = [];
  subModules: SubModule[] = [];
  subSubModules: SubSubModule[] = [];
  allModule: AllModule[] = [];
  selectedModule: number;
  selectedSubModule: number;
  selectedSubSubModule: number;
  pageurl: PageUrl = new PageUrl();
  icon: Icon = new Icon();
  pageBinding: PageBinding = new PageBinding();
  page: string;

  menuBottomPartVisible: boolean = true;

  userLogInDetail: UserLogInDetail;
  chooseLocData: UserLogInDetail;
  changePwdForm: UntypedFormGroup;
  existingInternationalizationSetup: Internationalization = new Internationalization();

  //subscription
  moduleSubscription: Subscription;
  subModuleSubscription: Subscription;
  getUserProfileSubscription: Subscription;
  changePwdSubscription: Subscription;
  subSubModuleSubscription: Subscription;
  private initialDataSubscription: Subscription;
  private insertErrorLogSubscription: Subscription;
  private onViewSetUpSubscription: Subscription;

  currentRoute: string;
  event$: Subscription;
  subMenuId: number;
  menuId: number;
  subSubMenuId: number;
  nextPage: string;
  el: any;
  ModuleWisePermissions: any;
  userId: String;
  modulesAllowed: string[] = [];
  directMenuClicked: boolean = true;
  noOfDaysAllowed: number;
  urlData: string;
  lastUrl: string;
  updateStatusProvisionSub: Subscription;
  subSubGroupName: string;
  subscription: Subscription;
  migratingPage: boolean = true;
  datepipe: DatePipe;
  stepper: any;
  speech: any;
  speechData: any;
  recognition: any;
  text: string;
  tempWords: string;
  isStoppedSpeechRecog: boolean;
  freaquencyRange: number[] = [];
  pageLoaded: boolean = false;
  selectedCustomer: Customer = new Customer();
  scannerEnabled: boolean;
  information: string;
  qrResultString: any;

  errorLog: ErrorLog = new ErrorLog();
  isAndroid: boolean = false;

  menuHeader: any = [];

  lastloc: number = 0;
  appitemsTravel: any = [];
  user: any;
  noOfTimesIdle: number;
  timedOutInSec: number;
  isPlayingAudio: boolean;

  tempData: string;
  dialogRef: any;
  showPage: boolean = true;
  channel: BroadcastChannel;
  token: string = '';
  intervalId: NodeJS.Timeout;
  notificationAllowed = false;
  isDarkTheme = false;
  themeOptions = [
    { value: 'default', label: 'Default' },
    { value: 'dark', label: 'Dark' },
    { value: 'user', label: 'User Customization' }
  ];
  selectedTheme = 'default';
  private initInterval: any;
  private createSubscription: Subscription;
  constructor(
    private positionService: CustomOverlayPositionService,
    private overlay: Overlay,
    private fcm: MessagingService,
    private ks: KeyboardShortcutService,
    private jwtService: JwtService,
    private route: ActivatedRoute,
    // @Inject(OKTA_AUTH) public oktaAuth: OktaAuth,
    private changeDetector: ChangeDetectorRef,
    private location: LocationStrategy,
    private locationCommon: Location,
    private commonService: CommonService,
    private apiUrl: APIFactoryEndPoints,
    //public keepalive: Keepalive,
    public containerService: MainContainerService,
    public router: Router,
    //private idle: Idle,
    private datePipe: DatePipe,
    // iconRegistry: MatIconRegistry,
    // sanitizer: DomSanitizer,
    // private oktaCustomApiService: OktaCustomAPIService,
    private formBuilder: UntypedFormBuilder,
    private toastService: ToastService,
    //private angularFireMessaging: AngularFireMessaging,
    public persistenceService: LocalStorageService,
    private posService: PosService,
    private activatedRoute: ActivatedRoute,
    private themeService: ThemeService,
    private dialog: MatDialog,
    private dateAdapter: DateAdapter<Date>,
    private jWTDecodeService: JwtDecodeService,
    private idle: IdleService,
    private appConfig: AppConfigService,
    private masterContainerService: MastercontainerService,
    private webOrderService: WebOrderService,
    private bottomSheet: MatBottomSheet,
    private deviceDetector: DeviceDetectorService,
    private ngZone: NgZone,
    private masterFunctionService: MasterfunctionService,
  ) {

    // console.log(this.router.url);
    this.dateAdapter.setLocale('en-GB');
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        if (window.location.href.includes("access_token=")) {

          this.token = this.getQueryString("access_token");
          let id_token = this.getQueryString("refresh_token");
          //this.token=this.token.replaceAll("NA/login?access_token=","NA")
          console.log("Token Get 2: " + this.token)
          this.persistenceService.set("access_token", this.token);
          console.log("ID Token Get222222222222222222: " + id_token)
          const url = new URL(window.location.href);
          url.searchParams.delete('access_token');
          url.searchParams.delete('refresh_token');
          url.searchParams.delete('id_token');
          window.history.replaceState({}, document.title, url.toString());

        }
      }
      if (e instanceof NavigationEnd) {
        this.token = this.getQueryString("access_token") || this.persistenceService.get('access_token');
        if (this.token != null) {
          this.checkAuthenticatedOrNot();
        }

      }
    });
    let refresh_token = this.getQueryString("refresh_token");
    if (refresh_token != null) {
      console.log("Refresh Token === " + refresh_token)
      this.persistenceService.set("refresh_token", refresh_token)
    }

    window.addEventListener('ReceivedDeviceInfo', function (event) {
      // this.persistenceService.set('locId',localStorage.getItem('locId'))
      // this.persistenceService.set('DeviceID',localStorage.getItem('DeviceID'))
    });

    this.nos = 0;
    window.addEventListener('ReceivedNotification', function (event) {
      console.log('Notification received event: ' + event);
      if (this.nos == undefined || Number.isNaN(this.nos)) this.nos = 1;
      else this.nos++;
      console.log('Notification received : ' + this.nos);
      if (this.nos > 0) {
        //alert("You have a message")
        // document.getElementById("badge").style.display = 'block';
        // this.hideMatBadge = false;
      } else {
        // document.getElementById("badge").style.display = 'none';
        //this.hideMatBadge = true;
      }
    });

    this.persistenceService.set('orderRateFormat', '1.0-3');
  }

  getQueryString(p1: string) {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    return params.get(p1);
  }

  async checkAuthenticatedOrNot() {
    // this.isAuthenticated = await this.oktaAuth.isAuthenticated();
    // if (
    //   !this.isAuthenticated ||
    //   this.persistenceService.get('access_token') == null
    // ) {
    //   this.showPage = true;
    //   this.router.navigateByUrl('okta-login');
    //   return;
    // }
    // if (this.persistenceService.get('locId') != null) {
    //   if (this.userLogInDetail == null) {
    //     this.userLogInDetail = new UserLogInDetail();
    //     this.userLogInDetail.userId = this.persistenceService.get('userId');
    //     this.userLogInDetail.userName = this.persistenceService.get('userName');
    //     this.userLogInDetail.userEmail =
    //       this.persistenceService.get('userEmail');
    //     this.userLogInDetail.company = JSON.parse(
    //       this.persistenceService.get('company')
    //     );
    //     this.userLogInDetail.location = JSON.parse(
    //       this.persistenceService.get('location')
    //     );
    //   }
    //   if (this.userLogInDetail.userId != null) {
    //     console.log('Pushing User Id : ' + this.userLogInDetail.userId);
    //     setUserIdFromApp(this.userLogInDetail.userId);
    //   }
    //   if (this.allModule != null) {
    //     if (this.allModule.length == 0) {
    //       this.getAllModuleSubModuleSubSubModule();
    //     }
    //   }
    // }

    if (this.token == undefined || this.token == "NA" || this.token == null || this.token == '')
      this.isAuthenticated = false
    else
      this.isAuthenticated = this.jWTDecodeService.isTokenValid(this.token)
    if (!this.isAuthenticated) {
      this.inLoginPage = true
      this.showPage = true
      this.router.navigateByUrl("login")
      return;
    }
    else {
      let decodedToken: any = this.jWTDecodeService.decodeToken(this.token);
      // console.log(decodedToken);
      // console.log("Token Get 1: " + this.token)
      this.persistenceService.set('access_token', this.token)
      this.persistenceService.set("token_source", decodedToken.token_source)
      this.persistenceService.set("userId", decodedToken.uid)
      this.persistenceService.set("userName", decodedToken.user_name)
      this.persistenceService.set("userEmail", decodedToken.email)
      this.persistenceService.set("id_token", decodedToken.id_token)
      if (this.persistenceService.get("allEMails") == undefined || this.persistenceService.get("allEMails") == null) {
        this.persistenceService.set("allEMails", decodedToken.email)
      }
      else {
        if (!this.persistenceService.get("allEMails").includes(decodedToken.email))
          this.persistenceService.set("allEMails", this.persistenceService.get("allEMails") + "," + decodedToken.email)
      }
      if (this.userLogInDetail == null) {
        this.userLogInDetail = new UserLogInDetail();
        this.userLogInDetail.userId = this.persistenceService.get("userId")
        this.userLogInDetail.userName = this.persistenceService.get("userName")
        this.userLogInDetail.userEmail = this.persistenceService.get("userEmail")
        this.userLogInDetail.company = JSON.parse(this.persistenceService.get("company"));
        this.userLogInDetail.location = JSON.parse(this.persistenceService.get("location"));
      }
      if (this.userLogInDetail.userId != null) {
        // console.log('Pushing User Id : ' + this.userLogInDetail.userId);
        setUserIdFromApp(this.userLogInDetail.userId);
      }
      if (this.allModule != null) {
        if (this.allModule.length == 0) {
          this.getAllModuleSubModuleSubSubModule();
        }
      }

    }
  }
  getInternationalizationSetup() {
    this.initialDataSubscription = this.masterContainerService
      .getInternationalizationInitialData(this.apiUrl.getInternationalizationInitialDataByUserId)
      .subscribe((data: any) => {
        if (data) {
          this.existingInternationalizationSetup = data;

          this.setIfPresent('isCommaSeparatorEnabled', this.existingInternationalizationSetup.showCommaSeparator);
          this.setIfPresent('roundOffFormat', this.existingInternationalizationSetup.amountFormat);
          this.setIfPresent('quantityFormat', this.existingInternationalizationSetup.quantityFormat);
          this.setIfPresent('rateFormat', this.existingInternationalizationSetup.rateFormat);
          this.setIfPresent('totalFormat', this.existingInternationalizationSetup.totalFormat);
          this.setIfPresent('showCurrency', this.existingInternationalizationSetup.showCurrencySymbol);
          this.setIfPresent('currencyCode', this.existingInternationalizationSetup.currency);

          // Always set this one
          this.persistenceService.set('flexibleDecimalFormat', '1.0-10');
        }
        if (this.existingInternationalizationSetup.theme !== null && this.existingInternationalizationSetup.theme !== undefined) {
          this.onThemeChange(this.existingInternationalizationSetup.theme, true);
        }
        if (this.existingInternationalizationSetup.language !== null && this.existingInternationalizationSetup.language !== undefined) {
          this.changeLanguage(this.existingInternationalizationSetup.language, true);
        }
      });
  }
  private setIfPresent(key: string, value: any): void {
    if (value !== null && value !== undefined) {
      this.persistenceService.set(key, `${value}`);
    }
  }
  openChooseLocDialog() {
    this.closeNav();
    if (this.persistenceService.get('userDetails') != null) {
      this.userLogInDetail = JSON.parse(
        this.persistenceService.get('userDetails')
      );
    }
    this.userLogInDetail.parentLocRefNo = parseInt(
      this.persistenceService.get('parentLocRefNo')
    );
    let dialogConfig: MatDialogConfig = {
      disableClose: true,
      autoFocus: true,
      panelClass: 'full-screen-modal',
      maxWidth: '100%',
      height: '100%',
      width: '100%',
      data: this.userLogInDetail,
    };
    let dialogRef = this.dialog.open(
      ChooseLocationDialogComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((data) => {
      if (data != null && data != undefined) {
        // this.chooseLocData = data;
        // this.persistenceService.set("company", JSON.stringify(this.chooseLocData.company));
        // this.persistenceService.set("location", JSON.stringify(this.chooseLocData.location));
        // this.persistenceService.set("locId", JSON.stringify(this.chooseLocData.location.refNo));
        // this.persistenceService.set("parentLocationName", JSON.stringify(this.chooseLocData.parentLocationName));
        // this.persistenceService.set("parentLocRefNo", JSON.stringify(this.chooseLocData.parentLocRefNo));
        // //this.router.navigateByUrl("dashboard")
        // console.log(this.chooseLocData);
        // console.log(this.persistenceService.get("company"));
        window.location.reload();
        //For Android App
        if (this.isNativeApp()) {
          this.toastService.showSuccessToast("Location changed successfully. Reloading the app...");
          (window as any).app.reloadFromAndroid();
        }

      }
    });
  }

  ngAfterViewInit() {

    // Run interval OUTSIDE Angular zone so it doesn't trigger endless change detection
    this.ngZone.runOutsideAngular(() => {
      this.initInterval = setInterval(() => {
        if (
          typeof google !== 'undefined' &&
          google.translate &&
          google.translate.TranslateElement &&
          document.getElementById('google_translate_element')
        ) {
          clearInterval(this.initInterval);

          new google.translate.TranslateElement(
            {
              pageLanguage: 'en',
              includedLanguages: 'en,hi',
              autoDisplay: false
            },
            'google_translate_element'
          );

          console.log('[Google Translate] Initialized successfully in AppComponent');
        }
      }, 200);
    });
    const buttons = document.querySelectorAll('button');

    // console.log('Total buttons found:', buttons.length);
    buttons.forEach((btn, i) => {
      // console.log(i, btn.innerText.trim());
    });

    if (!this.isNativeApp()) {

      const currentToken = this.persistenceService.get('FirebaseToken');
      this.fCMMessageRegistration = new FCMMessageRegistration();
      this.fCMMessageRegistration.locId = parseInt(
        this.persistenceService.get('locId')
      );
      if (this.persistenceService.get('userId') != undefined)
        this.fCMMessageRegistration.locCusId =
          this.persistenceService.get('userId');
      else
        this.fCMMessageRegistration.locCusId =
          this.persistenceService.get('DeviceID');
      this.fCMMessageRegistration.token = currentToken;
      if (
        this.persistenceService.get('DeviceID') == null ||
        this.persistenceService.get('DeviceID') == ''
      ) {
        this.persistenceService.set('DeviceID', this.generateUniqueID());
      }
      this.fCMMessageRegistration.deviceId = this.persistenceService.get('DeviceID');
      this.fCMMessageRegistration.deviceType = 'Web';
      document.getElementById('deviceId').innerHTML = this.persistenceService.get('DeviceID');

      // console.log('FCM Web Token Saved1=' + this.fCMMessageRegistration.deviceId);
      // console.log('FCM Web Token Saved2=' + currentToken);
      // console.log('FCM Web Token Saved4=' + this.persistenceService.get('locId'));
      // console.log('FCM Web Token Saved5=' + this.persistenceService.get('access_token'));
      // console.log('FCM Web Token Saved6=' + this.fCMMessageRegistration.token);
    }

    // const originalCreate = this.overlay.create.bind(this.overlay);

    // this.overlay.create = (config) => {
    //   const overlayRef = originalCreate(config);

    //   // Only apply to mat-select panels
    //   if (config.panelClass?.includes('custom-select-panel')) {
    //     setTimeout(() => {
    //       const trigger = document.activeElement as HTMLElement;
    //       if (trigger) {
    //         this.positionService.applySmartPosition(
    //           overlayRef,
    //           trigger
    //         );
    //       }
    //     });
    //   }

    //   return overlayRef;
    // };

  }

  private async initFcmToken() {
    try {
      const token = await this.fcm.requestPermissionAndGetToken();
      if (token) {
        this.handleToken(token);
      }
    } catch (e) {
      console.error('FCM init failed', e);
    }
  }

  handleToken(token: string) {
    if (!token) return;

    const locId = this.persistenceService.get('locId');
    if (!locId || locId === 'NA') {
      console.log('⏳ Location not selected — will register later');
      return;
    }

    // const registeredToken = this.persistenceService.get('FirebaseTokenRegistered');
    // const registeredTime = this.persistenceService.get('FirebaseTokenRegisteredTime');

    // // store latest token
    // this.persistenceService.set('FirebaseToken', token);

    // let shouldRegister = false;

    // // ⭐ token changed
    // if (registeredToken !== token) {
    //   console.log('🔄 Token changed → registering');
    //   shouldRegister = true;
    // }

    // // ⭐ check 3 day expiry
    // if (registeredTime) {
    //   const lastTime = new Date(registeredTime).getTime();
    //   const now = new Date().getTime();
    //   const diffDays = (now - lastTime) / (1000 * 60 * 60 * 24);

    //   if (diffDays >= 3) {
    //     console.log('⏰ 3 days passed → refreshing token registration');
    //     shouldRegister = true;
    //   }
    // } else {
    //   shouldRegister = true;
    // }

    // if (!shouldRegister) {
    //   console.log('✅ Token already registered recently — skipping API');
    //   return;
    // }

    // build registration object
    this.fCMMessageRegistration = new FCMMessageRegistration();
    this.fCMMessageRegistration.deviceId = this.persistenceService.get('DeviceID');
    this.fCMMessageRegistration.locId = Number(locId);

    if (this.persistenceService.get('userId')) {
      this.fCMMessageRegistration.locCusId = this.persistenceService.get('userId');
    } else {
      this.fCMMessageRegistration.locCusId = this.persistenceService.get('DeviceID');
    }

    this.fCMMessageRegistration.token = token;
    this.fCMMessageRegistration.deviceType = 'Web';
    this.fCMMessageRegistration.applicationName = 'MBS';

    this.saveFCMTokenData(token);
  }

  saveFCMTokenData(currentToken: any) {
    // console.log('DEBUG FCM CONDITIONS', {
    //   userId: this.persistenceService.get('userId'),
    //   deviceId: this.fCMMessageRegistration?.deviceId,
    //   locId: this.persistenceService.get('locId'),
    //   accessToken: this.persistenceService.get('access_token'),
    //   regToken: this.fCMMessageRegistration?.token,
    //   allowedAccess: this.persistenceService.get('AllowedAccess'),
    //   currentToken,
    //   storedToken: this.token,
    //   lastloc: this.lastloc
    // });

    if (this.persistenceService.get('userId') != null && this.fCMMessageRegistration.deviceId != null &&
      (currentToken != this.token || Number(this.persistenceService.get('locId')) != this.lastloc) &&
      this.persistenceService.get('locId') != 'null' && this.persistenceService.get('access_token') != null &&
      !window.location.toString().includes('okta-login') && this.fCMMessageRegistration.token != null) {
      // console.log('FCM Web Token Saved9=' + (this.persistenceService.get('userId') != 'NA'));
      // console.log('FCM Web Token Saved10=' + this.fCMMessageRegistration.deviceId);
      // console.log('FCM Web Token Saved11=' + (this.persistenceService.get('locId') != 'NA'));
      if (this.persistenceService.get('userId') != 'NA' && this.fCMMessageRegistration.deviceId != 'NA' &&
        this.fCMMessageRegistration.locId && this.persistenceService.get('locId') != 'NA') {
        // console.log('FCM Web Token Saved12=');
        if (this.persistenceService.get('AllowedAccess') == 'No') return;
        if (!window.location.href.includes('okta-login')) {
          this.fCMMessageRegistration.applicationName = 'MBS';
          this.commonService.saveFCMRegistrationData(this.apiUrl.saveUsersaveTokenIdLocId, this.fCMMessageRegistration)
            .subscribe((data: any) => {
              // console.log('FCM Token Saved For Web in DB', data);
              this.commonService.setAllowedFinancialYear(data.allowedFinancialYear);
              this.persistenceService.set('noOfDaysAllowed', String(data.noOfDays));
              this.token = currentToken;
              this.lastloc = Number(this.persistenceService.get('locId'));
              // ⭐ mark registered AFTER API call ideally
              this.persistenceService.set('FirebaseTokenRegistered', currentToken);
              this.persistenceService.set('FirebaseTokenRegisteredTime', new Date().toISOString());
            });
        }
      }

    }
    // else {
    //   console.log('Hello from ReceivedDeviceInfo1=');
    //   const currentToken = localStorage.getItem('FirebaseToken');
    //   console.log('Hello from ReceivedDeviceInfo2=');
    //   this.fCMMessageRegistration = new FCMMessageRegistration();
    //   this.fCMMessageRegistration.locId = parseInt(
    //     this.persistenceService.get('locId')
    //   );
    //   if (this.persistenceService.get('userId') != undefined)
    //     this.fCMMessageRegistration.locCusId =
    //       this.persistenceService.get('userId');
    //   else
    //     this.fCMMessageRegistration.locCusId =
    //       this.persistenceService.get('DeviceID');
    //   this.fCMMessageRegistration.token = currentToken;
    //   this.fCMMessageRegistration.deviceType = 'Mob';
    //   if (localStorage.getItem('DeviceID') != null) {
    //     this.fCMMessageRegistration.deviceId = localStorage.getItem('DeviceID');
    //   } else this.fCMMessageRegistration.deviceId = 'NA';
    //   document.getElementById('deviceId').innerHTML =
    //     this.persistenceService.get('DeviceID');
    //   console.log(
    //     'FCM Mob Token Saved1=' + this.fCMMessageRegistration.deviceId
    //   );
    //   console.log('FCM Mob Token Saved2=' + currentToken);
    //   console.log('FCM Mob Token Saved3=' + this.token);
    //   console.log(
    //     'FCM Mob Token Saved4=' + this.persistenceService.get('locId')
    //   );
    //   console.log(
    //     'FCM Mob Token Saved5=' + this.persistenceService.get('access_token')
    //   );
    //   console.log('FCM Mob Token Saved6=' + this.fCMMessageRegistration.token);
    //   console.log(
    //     'FCM Mob Token Saved7=' + this.persistenceService.get('userId')
    //   );
    //   console.log(
    //     'FCM Mob Token Saved8=' + this.fCMMessageRegistration.deviceId
    //   );
    //   if (
    //     this.persistenceService.get('userId') != null &&
    //     this.fCMMessageRegistration.deviceId != null &&
    //     (currentToken != this.token ||
    //       Number(this.persistenceService.get('locId')) != this.lastloc) &&
    //     this.persistenceService.get('locId') != 'null' &&
    //     this.persistenceService.get('access_token') != null &&
    //     !window.location.toString().includes('okta-login') &&
    //     this.fCMMessageRegistration.token != null
    //   ) {
    //     console.log(
    //       'FCM Mob Token Saved9=' +
    //         (this.persistenceService.get('userId') != 'NA')
    //     );
    //     console.log(
    //       'FCM Mob Token Saved10=' + this.fCMMessageRegistration.deviceId
    //     );
    //     console.log(
    //       'FCM Mob Token Saved11=' +
    //         (this.persistenceService.get('locId') != 'NA')
    //     );
    //     if (
    //       this.persistenceService.get('userId') != 'NA' &&
    //       this.fCMMessageRegistration.deviceId != 'NA' &&
    //       this.persistenceService.get('locId') != 'NA'
    //     ) {
    //       console.log('FCM Mob Token Saved12=');
    //       if (this.persistenceService.get('AllowedAccess') == 'No') return;
    //       this.fCMMessageRegistration.applicationName = 'MBS';
    //       this.commonService
    //         .saveFCMRegistrationData(
    //           this.apiUrl.saveUsersaveTokenIdLocId,
    //           this.fCMMessageRegistration
    //         )
    //         .subscribe((data: any) => {
    //           console.log('FCM Token Saved For Mob in DB');
    //           this.persistenceService.set('noOfDaysAllowed', data.noOfDays);
    //           this.token = currentToken;
    //           this.lastloc = Number(this.persistenceService.get('locId'));
    //         });
    //     }
    //   }
    // }

  }

  async ngOnInit() {
    //const token = await this.fcm.requestPermissionAndGetToken();

    // this.fcm.requestPermissionAndGetToken().then(token => {
    //   console.log('FCM Token N :', token);
    // });
    // console.log("User FCM Token:", token);

    this.isDarkTheme = this.themeService.getCurrentTheme();
    if (this.isDarkTheme) {
      this.selectedTheme = 'dark';
    } else if (this.themeService.isUserThemeApplied()) {
      this.selectedTheme = 'user';
    } else {
      this.selectedTheme = 'default';
    }
    // User theme is applied only when saving in internationalization setup, not on app init
    // const savedTheme = JSON.parse(this.persistenceService.get('appThemeConfig'));
    // this.themeService.applyusertheme(savedTheme);

    //below is our by default format 
    this.persistenceService.set('isCommaSeparatorEnabled', 'true');
    this.persistenceService.set('roundOffFormat', '1.2-2');
    this.persistenceService.set('quantityFormat', '1.2-3');
    this.persistenceService.set('rateFormat', '1.0-2');
    this.persistenceService.set('totalFormat', '1.0-0');
    this.persistenceService.set('showCurrency', 'false');
    this.persistenceService.set('currencyCode', 'INR');
    this.persistenceService.set('flexibleDecimalFormat', '1.0-10');
    this.getInternationalizationSetup();


    const firebaseConfig = this.appConfig.setting.firebase;
    if (firebaseConfig) {
      initializeApp(firebaseConfig);
      console.log('✅ Firebase initialized with dynamic config');
    } else {
      console.error('⚠️ Firebase config not loaded!');
    }
    this.idle.startWatching();
    this.idle.warning$.subscribe(seconds => {
      if (!this.dialogRef) {
        this.dialogRef = this.dialog.open(IdleWarningDialogComponent, {
          width: '380px',
          disableClose: true,
          data: { seconds }
        });

        this.dialogRef.afterClosed().subscribe(() => {
          this.dialogRef = null;
        });
      } else {
        // Update countdown in dialog
        this.dialogRef.componentInstance.data.seconds = seconds;
      }
    });

    this.idle.timeout$.subscribe(() => {
      this.dialogRef?.close();
      this.dialogRef = null;
      this.persistenceService.set('access_token', null);
      // LOGOUT HERE
      sessionStorage.clear();
      if (this.isNativeApp()) {
        console.log("Logout3")
        logOutApp()
      }

      else {
        window.location.href = this.appConfig.setting.loginLogoutUrl + "signin?cnt=1&source=" + window.location.origin + "/";
      }

    });


    // this.route.queryParams.subscribe(params => {
    //   const message = params['id_token'];
    //   if (message != undefined) {
    //     try {
    //       const userEmail = this.jwtService.getClaim(message.replace(":", ""), 'email');
    //       console.log('User Email:', userEmail);

    //     } catch (error) {
    //       console.error('Invalid token', error);
    //       return null;
    //     }
    //   }
    // });
    //this.runShellCommand();
    //console.log(import.meta.url);
    // const eventSource = new EventSource(this.apiUrl.testSSE);
    // eventSource.addEventListener('message', (e) => {
    //   console.log("Received From Server : "+e.data);
    // });

    //console.log("Test Enc Data=" + CryptoJS.AES.encrypt("ABCDEFGHIJKLMNOPQRSTUVWXYZ09876543211234567890abcdefghijklmnopqrstuvwxyz", environment.pass))
    this.persistenceService.set('manageBeepAndTextList', '');
    // if (this.deviceDetector.getOS() != 'Android')
    //   this.runContiniously();
    if (!this.channel) {
      this.channel = new window.BroadcastChannel('bg-notification');
      this.channel.addEventListener('message', (e) => {
        this.nos = this.nos + 1;
        console.log(
          'Received Message Title : ' + e.data.payload.notification?.title
        );
        console.log(
          'Received Message Body : ' + e.data.payload.notification?.body
        );
        if (e.data.payload.notification.title == 'Full Data For Monitoring') {
          this.persistenceService.setMonitoringDashboardData(
            'monitoringDashboardData',
            e.data.payload.notification.body
          );
          // alert("Full Data For Monitoring");
          return;
        }
        //Ensure payload structure is correct
        const payload = e.data.payload;
        if (!payload || !payload.notification) {
          console.error('Invalid notification payload:', e.data);
          return;
        }

        //Call showSmallNotification correctly
        this.showSmallNotification(payload);
        // Parse the message body into a structured object
        const parsedMessage = this.parseMessageBody(e.data.payload.data.messageBody);
        if (e.data.payload.notification.title == 'Web Order' || e.data.payload.notification.title == 'Order Delivery' || e.data.payload.notification.title == 'Customized Product'
        ) {
          this.manageBeepAndTextList = this.persistenceService.get(
            'manageBeepAndTextList'
          );
          let message = e.data.payload.notification.body;
          this.webOrderRequest(
            parsedMessage.refNo,
            parsedMessage.message,
            parsedMessage.beep,
            parsedMessage.readMessage,
            parsedMessage.forModule
          );
        }

        if (e.data.payload.notification.title == 'Cancel Message') {
          let refNo = parsedMessage.refNo;
          let forModule = parsedMessage.forModule;
          this.cancelMessage(refNo, forModule);
        }
      });
    }
    // let oData="eyJraWQiOiJlS0pRM2NacEhwUGRMUFBpYWxKa2J0eFZFNnBQa0F4X2NrY2NVTndIZVEwIiwiYWxnIjoiUlMyNTYifQ.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.FMBzFIdkhf7vlS-ibznDz-g5dsspo87HOSUW184r8L8HFrNWcxi7w_eidq1DXrclhjzHOmkdMu8Ub7PyhUJry7EHjsC6g8BfsEq4pY2KDRI0mVNrbJO6-cKdG_UuzYRqAGMEIQuZ88f-eoPJUR8Y_lewEfK_2_wwJRaV01tWCgYZAcv0o3MGLtz8AuDbFuDlSM-SICMbIP5EdaYOvt12qGb-vFjlXkdoKpWElU2xF-17z5kmfyMghPsWINNcG8PBWmRd0pRc49w1FLZnFaNMMIrPdRdZMcy8TtJt_OOjc2d27TaMzWL1wKOiFlyD8WmHIKOEXdEh1ZT36JaZNY5ubQ"
    // console.log("Ori Data===" + this.decryptData(oData))
    // let data = this.encryptData(oData);
    // console.log("Dec Data===" + this.decryptData(data))

    this.persistenceService.set('OS', this.deviceDetector.getOS());

    if ((!this.isNativeApp() && window.location.origin.includes('localhost')) || window.location.origin.includes('mobitrix.net')) {
      if (!window.location.href.includes('http://192')) {
        // ✅ FIRE AND FORGET (no await)
        this.initFcmToken();
        // this.requestPermission();
        this.listen();
      }
    }

    if (!this.isNativeApp()) {
      if (getWindow().navigator.geolocation) {
        getWindow().navigator.geolocation.getCurrentPosition((position) => {
          this.persistenceService.set(
            'long',
            position.coords.longitude.toString()
          );
          this.persistenceService.set(
            'lat',
            position.coords.latitude.toString()
          );
        });
      }
    }

    this.router.events.forEach(async (event) => {

      if (event instanceof NavigationEnd) {
        // if (event.url == '/' || this.router.url.includes('/okta-login')) {
        if (event.url == '/' || this.router.url.includes('/login')) {
          this.showPage = true;
          this.inLoginPage = true;
        } else {
          this.inLoginPage = false;
          this.showPage = true; // ✅ Ensure content is visible for all authenticated routes
        }

        const el = document.getElementById('navMenuBar');

        if (this.inLoginPage) {
          el.style.visibility = 'hidden';
          el.style.height = '0px';
          // this.idle.stop();
        } else {
          el.style.visibility = 'inherit';
          el.style.height = '60px';
          //this.idle.watch();

          //this.getAllModuleSubModuleSubSubModule();
        }
      }
    });

    this.timedOutInSec = 15;
    this.noOfTimesIdle = 1;
    if (
      window.location.origin.includes('http://localhost') ||
      window.location.origin.includes('http://192.168.2.')
    )
      // this.idle.setIdle(300000);
      //else this.idle.setIdle(10800);
      //this.idle.setTimeout(this.timedOutInSec);
      //this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
      // this.idle.onIdleStart.subscribe(() => {
      //   console.log('idle start');
      //   this.noOfTimesIdle = 1;
      //   // show the modal
      // });

      // this.idle.onIdleEnd.subscribe(() => {
      //   console.log('not idle');
      //   this.dialogRef.close();
      //   // hide the modal
      // });

      // this.idle.onTimeoutWarning.subscribe((secondsLeft: number) => {
      //   console.log('logout Wrn');

      //   if (this.noOfTimesIdle == 1) {
      //     let dialogConfig: MatDialogConfig = {
      //       disableClose: true,
      //       autoFocus: true,
      //       panelClass: 'full-screen-modal',
      //       width: '30%',
      //       minWidth: 350,
      //       height: '20%',
      //       minHeight: 180,
      //       data: this.timedOutInSec,
      //     };

      //     this.dialogRef = this.dialog.open(DigitalClockComponent, dialogConfig);

      //     this.dialogRef.afterClosed().subscribe((data) => { });
      //   }
      //   this.noOfTimesIdle++;
      // });

      // this.idle.onTimeout.subscribe(() => {
      //   console.log('logout');
      //   this.dialogRef.close();
      //   this.logout();
      //   // Hide the modal, log out, do something else
      // });

      window.addEventListener('keyup', disableF5);
    window.addEventListener('keydown', disableF5);

    function disableF5(e) {
      if ((e.which || e.keyCode) == 116) e.preventDefault();
    }

    this.router.events
      .pipe(filter((rs): rs is NavigationEnd => rs instanceof NavigationEnd))
      .subscribe((event) => {
        if (event.id === 1 && event.url === event.urlAfterRedirects) {
          if (this.router.url == this.constant.URL_CASH_REGISTER) {
            let refNo = this.persistenceService.get('refNo');
            let status = this.persistenceService.get('organiserCurrentStatus');

            if (status == null) status = 'Idle';

            if (refNo)
              if (status === 'CheckedOut' || status === 'Idle')
                this.updateStatusProvisionSub = this.posService
                  .updateOrgDetailsStatusToOpen(
                    this.apiUrl.updateOrgDetailsStatusToIdle,
                    Number(refNo),
                    status
                  )
                  .subscribe();

            this.router.navigate([this.constant.URL_CASH_REGISTER]);
          } else if (
            this.router.url == this.constant.URL_CASH_REGISTER_WEBAPP
          ) {
            let refNo = this.persistenceService.get('refNo');
            let status = this.persistenceService.get('organiserCurrentStatus');

            if (status == null) status = 'Idle';

            if (refNo)
              if (status === 'CheckedOut' || status === 'Idle')
                this.updateStatusProvisionSub = this.posService
                  .updateOrgDetailsStatusToOpen(
                    this.apiUrl.updateOrgDetailsStatusToIdle,
                    Number(refNo),
                    status
                  )
                  .subscribe();

            this.router.navigate([this.constant.URL_CASH_REGISTER_WEBAPP]);
          }
        }
      });
    // this.getAllowedFinancialYear();
    // this.getPendingWebOrders();
  }

  @HostListener('window:ReceivedPushedOrder', ['$event'])
  ReceivedPushedOrder(event) {
    console.log('Received Title=11=' + event.detail?.title);
    console.log('Received Body=22=' + event.detail?.body);
    console.log('Received Data=33=' + event.detail?.data);
    // Parse the message body into a structured object
    const parsedMessage = this.parseMessageBody(event.detail?.data);
    if (event.detail?.title == 'Web Order' || event.detail?.title == 'Order Delivery' || event.detail?.title == 'Customized Product') {
      this.webOrderRequest(parsedMessage.refNo, parsedMessage.message, parsedMessage.beep, parsedMessage.readMessage, parsedMessage.forModule);
    }
  }

  @HostListener('window:LongLatRec', ['$event'])
  LongLatRec(event) {
    console.log('Storing Lat/Long Data : ' + event.detail.long);
    this.persistenceService.set('long', event.detail.long);
    this.persistenceService.set('lat', event.detail.lat);
  }

  @HostListener('window:SSEMessage', ['$event'])
  onMessage(event) {
    var data = JSON.parse(event.detail.resp);
    console.log('Data : ' + data);
    console.log('deviceId : ' + data.deviceId);
    console.log('message Title: ' + data.messageTitle);
    console.log('message Body : ' + data.messageBody);
    console.log('forModule : ' + data.forModule);
    console.log('transactionNo : ' + data.transactionNo);
    console.log('beepYesNo : ' + data.beepYesNo);
    console.log('readMessageYesNo : ' + data.readMessageYesNo);
    this.manageBeepAndTextList = this.persistenceService.get(
      'manageBeepAndTextList'
    );
    if (data.messageTitle == 'App Update')
      this.appUpdateForDevices(data.deviceId, data.transactionNo);
    if (data.messageTitle == 'Order Delivery')
      this.webOrderRequest(
        data.refNo,
        data.messageBody,
        data.beep,
        data.readMessage,
        data.forModule
      );
    if (data.messageTitle == 'Web Order')
      this.webOrderRequest(
        data.refNo,
        data.messageDetails,
        data.beep,
        data.readMessage,
        data.forModule
      );
    if (data.messageTitle == 'Customized Product')
      this.webOrderRequest(
        data.refNo,
        data.messageDetails,
        data.beep,
        data.readMessage,
        data.forModule
      );
    if (data.messageTitle == 'Cancel Message')
      this.cancelMessage(data.refNo, data.forModule);
  }
  appUpdateForDevices(deviceId: string, refNo: string) {
    appUpdateForDevice(deviceId, refNo);
  }

  openNav() {
    if (this.inLoginPage) {
      this.toastService.showErrorToast(this.constant.signInToast);
    } else {
      document.getElementById('myNav').classList.remove('close-nav');
      document.getElementById('myNav').classList.add('open-nav');
    }
  }

  closeNav() {
    document.getElementById('myNav').classList.remove('open-nav');
    document.getElementById('myNav').classList.add('close-nav');
  }
  getAllModuleSubModuleSubSubModule() {
    this.allModule = [];
    // let locId = JSON.parse(this.persistenceService.get('location')).refNo;
    let locId = JSON.parse(this.persistenceService.get('location') || '{}')?.refNo ?? null;
    // console.log(this.router.url);
    // if (this.router.url == '/okta-login' || !locId) {
    if (this.router.url.includes('/login') || !locId) {
      this.showPage = true;
      return;
    }

    this.moduleSubscription = this.containerService
      .getAllWebModules(locId)
      .subscribe(
        (data: any) => {
          this.allModule = data;
          if (this.allModule.length > 0) {
            this.appitemsTravel = this.allModule;

            if (
              this.getCookie('lastPage') == undefined ||
              this.getCookie('lastPage') == window.location.origin + '/' ||
              this.getCookie('lastPage') == window.location.origin ||
              this.getCookie('lastPage') == null
            ) {
              this.setCookie('lastPage', window.location.origin + '/dashboard');
              this.router.navigate([this.constant.URL_DASHBOARD]);
              getWindow().location.reload();
            }
          }
          this.reverseTrackSubSubMenuToMenu(this.router.url.replace('/', ''));
        },
        (error: HttpErrorResponse) => {
          if (this.persistenceService.get("access_token") == undefined || this.persistenceService.get("access_token") === "NA") {
            if (this.isNativeApp()) {
              console.log("Logout4")
              logOutApp()
            }
            else {
              window.location.href = this.appConfig.setting.loginLogoutUrl + "signin?cnt=1&source=" + window.location.origin + "/";
            }

          }
          else
            this.insertErrorLog('getModules', error);
        }
      );
  }

  generateUniqueID() {
    var s = [];
    var hexDigits = '0123456789abcdef';
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-';
    var uuid = s.join('');
    return uuid;
  }
  // getOS() {
  //   var uA = getWindow().navigator.userAgent || getWindow().navigator.vendor;
  //   if (
  //     /iPad|iPhone|iPod/.test(uA) ||
  //     (uA.includes('Mac') && 'ontouchend' in document)
  //   )
  //     return 'iOS';
  //   // if (this.getBrowserName().includes("Safari"))
  //   //   return "Android"
  //   // else
  //   //   return "Windows"
  //   var i,
  //     os = ['Windows', 'Android', 'Unix', 'Mac', 'Linux', 'BlackBerry'];
  //   for (i = 0; i < os.length; i++)
  //     if (new RegExp(os[i], 'i').test(uA))
  //       if (os[i] != 'Android') return 'Web';
  //       else return os[i];
  // }

  /**
   * Check if app is running in native Android app context (not browser)
   * Native app has window.app object with native methods
   */
  isNativeApp(): boolean {
    return !!(window as any).app &&
      typeof (window as any).app.reloadFromAndroid === 'function';
  }

  /**
   * Check if running on Android browser (not native app)
   */
  isAndroidBrowser(): boolean {
    return this.deviceDetector.getOS() === 'Android' && !this.isNativeApp();
  }

  login() {
    // this.oktaAuth.signInWithRedirect({
    //   originalUri: '/okta-login'
    // });
  }

  async logout() {
    this.toastService.showSuccessToast(this.constant.logoutToast);
    // //this.persistenceService.set("lastActivityTime","2023-01-01 00:00:00")
    // this.commonService
    //   .revokeSessionPermission(this.apiUrl.revokeSession)
    //   .subscribe(async (data: any) => {
    //     if (data.status == 'Success') {
    //       this.oktaAuth.closeSession();
    //       this.isAuthenticated = false;
    //       this.oktaAuth.revokeAccessToken();
    //       this.oktaAuth.revokeRefreshToken();
    //       this.persistenceService.set('access_token', null);
    //       this.allModule = null;
    //       this.showPage = true;

    //       this.router.navigateByUrl('okta-login');
    //     } else {
    //       this.toastService.showSuccessToast(this.constant.ClearCacheToast);
    //     }
    //   });
    if (this.persistenceService.get("token_source") == "Okta") {
      await this.sleep(1000);
      this.persistenceService.set("access_token", "NA")
      this.persistenceService.set("refresh_token", "NA")
      this.isAuthenticated = false;
      this.allModule = null
      this.showPage = false
      this.inLoginPage = true
      if (this.isNativeApp()) {
        console.log("Logout5")
        logOutApp()
      }
      else {
        window.location.href = this.appConfig.setting.loginLogoutUrl + "signin?cnt=1&source=" + window.location.origin + "/";
      }

      return;
    }
    else {
      let token = this.persistenceService.get("id_token");
      if (!this.isNativeApp()) {
        const response = await fetch("https://oauth2.googleapis.com/revoke", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          body: `token=${token}`
        });
        await this.sleep(1000);
        window.location.href = window.location.origin + "/login";
      } else {
        console.log("Logout6")
        logOutApp()
        return;
      }

      localStorage.removeItem('isDarkTheme');
      this.persistenceService.set("access_token", "NA")
      this.persistenceService.set("refresh_token", "NA")
      this.persistenceService.set("user_details", null);
      this.isAuthenticated = false;
      this.allModule = null
      this.showPage = false
      this.inLoginPage = true

      let cnt = 1;
      if (this.persistenceService.get("allEMails") == undefined || this.persistenceService.get("allEMails") == null) {
        cnt = 1
      }
      else {
        cnt = this.persistenceService.get("allEMails").split(",").length
      }

      if (this.isNativeApp()) {
        console.log("Logout3")
        logOutApp()
      }
      else {
        window.location.href = this.appConfig.setting.loginLogoutUrl + "signin?cnt=" + cnt + "&source=" + window.location.origin + "/&target=logout";
      }

    }
  }

  sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  reverseTrackSubSubMenuToMenu(url: string) {
    // console.log('URL=' + url);
    if (url == 'dashboard' || url == 'not-authorized' || url == 'page-not-found' ||
      // url == 'okta-login'
      url == 'login'
      // || url == 'order/order/finishedgood'
    ) {
      this.showPage = true;
      return;
    }
    if (url == this.constant.URL_CASH_REGISTER) {
      url = this.constant.URL_POS;
    } else if (url == this.constant.URL_CASH_REGISTER_WEBAPP) {
      url = this.constant.URL_POS_WEBAPP;
    }
    this.isAndroid = this.persistenceService.get('OS') == 'Android' ? true : false;
    this.commonService.getSubSubModuleAndRefNoByInternalName(this.apiUrl.getSubSubModuleAndRefNoByInternalName, this.pageurl.getInternalNameByUrl(url, this.isAndroid))
      .subscribe((data: any) => {
        if (data.permittedOrNot == 1) {
          this.showPage = true;
          this.onSubSubModuleClicked(
            this.pageurl.getInternalNameByUrl(url, this.isAndroid),
            data.subSubModuleName,
            data.refNo
          );
        } else {
          this.showPage = true;
          this.router.navigateByUrl('not-authorized');
        }
      });

    if (url == 'not-authorized' || url == 'page-not-found') {
      this.showPage = true;
    }
  }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    this.errorLog.userId = this.persistenceService.get('userId');
    this.errorLog.dateAndTime = moment(new Date()).format(
      this.constant.dateTimeFormatForDBServer
    );
    this.errorLog.moduleName = 'AppComponent';
    this.errorLog.errorMethod = errorMethod;
    this.errorLog.platform = this.persistenceService.get('OS');
    if (error?.error?.message || error?.error?.message != '')
      this.errorLog.errorDetails = error.error.message;
    else this.errorLog.errorDetails = error.message;

    this.insertErrorLogSubscription = this.containerService
      .insertErrorLog(this.apiUrl.insertErrorLog, this.errorLog)
      .subscribe((data: any) => { });
  }

  getCookie(c_name) {
    var i,
      x,
      y,
      ARRcookies = document.cookie.split(';');
    for (i = 0; i < ARRcookies.length; i++) {
      x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
      y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
      x = x.replace(/^\s+|\s+$/g, '');
      if (x == c_name) {
        return unescape(y);
      }
    }
  }
  setCookie(name: string, val: any) {
    document.cookie = name + '=' + val;
  }

  getSubSubModuleData(routeName: string) {
    this.isAndroid =
      this.persistenceService.get('OS') == 'Android' ? true : false;
    let intenalName = this.pageurl.getInternalNameByUrl(
      routeName,
      this.isAndroid
    );
    let singleSubModule = null;
    this.allModule.forEach((x) => {
      x.items.forEach((y) => {
        if (y.items.some((z) => z.internalName == intenalName)) {
          singleSubModule = y.items.find((z) => z.internalName == intenalName);
        }
      });
    });
    if (singleSubModule) {
      this.onSubSubModuleClicked(
        singleSubModule.internalName,
        singleSubModule.label,
        singleSubModule.refNo
      );
    }
  }

  onSubSubModuleClicked(internalName: string, subSubModuleName: string, subSubGroupId: number) {
    this.isAndroid = this.persistenceService.get('OS') == 'Android' ? true : false;
    let internalPath = this.pageurl.getUrl(internalName, this.isAndroid);
    // console.log(internalPath);

    // // Maintenance restriction check
    // if (this.isRestrictedOrderModuleUser(internalPath)) {
    //   this.closeNav();
    //   this.showPage = true;
    //   this.router.navigateByUrl('order/order/finishedgood');
    //   return;
    // }


    this.router.navigateByUrl(internalPath);
    this.page = subSubModuleName;
    this.closeNav();
    this.persistenceService.set('addDisable', 'false');
    this.persistenceService.set('editDisable', 'false');
    this.persistenceService.set('viewDisable', 'false');
    this.persistenceService.set('cancelDisable', 'false');
    let data = new AuthorisationCreateViewEditCancel();
    this.subSubModuleSubscription = this.containerService.getCreateViewEditCancelPermissions(subSubGroupId).subscribe((data: AuthorisationCreateViewEditCancel) => {
      if (data.createAllow == 'Yes')
        this.persistenceService.set('addDisable', 'true');
      if (data.editAllow == 'Yes')
        this.persistenceService.set('editDisable', 'true');
      if (data.viewAllow == 'Yes')
        this.persistenceService.set('viewDisable', 'true');
      if (data.cancelAllow == 'Yes')
        this.persistenceService.set('cancelDisable', 'true');
      this.setCookie('lastPage', window.location.origin + this.router.url);

      this.showPage = true;
      let addTabIndex: number = 0;
      let viewTabIndex: number = 1;
      let editTabIndex: number = 2;
      let cancelTabIndex: number = 3;

      if (data.createAllow != 'Yes') {
        addTabIndex = -1;
        viewTabIndex = viewTabIndex - 1;
        editTabIndex = editTabIndex - 1;
        cancelTabIndex = cancelTabIndex - 1;
      }
      if (data.viewAllow != 'Yes') {
        viewTabIndex = -1;
        editTabIndex = editTabIndex - 1;
        cancelTabIndex = cancelTabIndex - 1;
      }
      if (data.editAllow != 'Yes') {
        editTabIndex = -1;
        cancelTabIndex = cancelTabIndex - 1;
      }
      if (data.cancelAllow != 'Yes') {
        cancelTabIndex = -1;
      }
      this.persistenceService.set('addTabIndex', addTabIndex.toString());
      this.persistenceService.set('viewTabIndex', viewTabIndex.toString());
      this.persistenceService.set('editTabIndex', editTabIndex.toString());
      this.persistenceService.set(
        'cancelTabIndex',
        cancelTabIndex.toString()
      );
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog('onSubSubModuleClick', error);
      }
    );
  }

  isRestrictedOrderModuleUser(internalPath: string): boolean {
    const userId = this.persistenceService.get('userId');

    // Allowed users
    const allowedUsers = ['00uzwe0uxcw0irtrL357', '00uxs1yypwqBFNTPG357', '00ulwsc3pazH9gN4h357', '00ulpsbyg0ahTCArV357',
      '00u2bwlor0xL9AR29357', '00uovq0ixfglHaPpR357', '00um3xcoc38NNsZZk357', '00um04ei2mw5Ths0Q357', 'd6qbztc694mkx9octfoy'];

    // Restricted order modules
    const restrictedOrderModules = ['finishedgoods', 'semifinishedgoods', 'make-to-order', 'rawmaterialsorderstock', 'tradegoods',
      'capitalgoods', 'scrap', 'others'];

    // Check module
    const isOrderModule = restrictedOrderModules.some(module => internalPath.toLowerCase() === `order/order/${module}`);

    // TRUE means redirect to maintenance page
    return (isOrderModule && !allowedUsers.includes(userId));
  }

  breadCrumbMain() {
    this.appitemsTravel = this.allModule;
    this.menuHeader = [];
  }

  breadCrumb(menu: any, index: number) {
    this.menuHeader.splice(index + 1, this.menuHeader.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.appitemsTravel = menu[index].items;
    }
  }

  menuChange(menuChange: any) {
    if (menuChange.items) {
      this.appitemsTravel = menuChange.items;
      this.menuHeader.push({
        label: menuChange.label,
        image: menuChange.image,
        items: menuChange.items,
      });
    }
  }

  //********************************************************************************************** */
  callNotification() {
    if (this.inLoginPage) {
      this.toastService.showErrorToast(this.constant.signInToast);
    } else {
      this.nos = 0;
      this.hideMatBadge = true;
      this.show = false;
      // this.router.navigateByUrl(this.constant.URL_VIEW_NOTIFICATION);
      this.router.navigateByUrl("message-center/messaging/create-notification");
      this.page = 'Notification';
      // this.makeDivHundred();
    }
  }

  callDashboard() {
    if (this.inLoginPage) {
      this.toastService.showErrorToast(this.constant.signInToast);
    } else {
      this.router.navigateByUrl('dashboard');
      this.page = 'Dashboard';
      // this.makeDivHundred();
    }
  }

  goBack() {
    // Log the current history length and the previous URL (if available)
    console.log('Current History Length:', window.history.length);
    console.log('Current Location:', window.location.origin);

    if (window.history.length > 1) {
      if (!window.location.href.toString().includes('/dashboard'))
        window.history.back();
    } else {
      console.warn('No history to go back to.');
    }
  }

  callMonitoringNotification() {
    if (this.inLoginPage) {
      this.toastService.showErrorToast(this.constant.signInToast);
    } else {
      this.reverseTrackSubSubMenuToMenu(this.constant.URL_MONITORING_DASHBOARD);
      // this.router.navigateByUrl(this.constant.URL_MONITORING_DASHBOARD);
      // this.page = "Monitoring Dashboard"
      // this.makeDivHundred();
    }
  }
  makeDivHundred() {
    getWindow().document.getElementById('right').style.width = '100%';
  }
  onChangePwdClick(event: any) {
    event.stopPropagation();
    this.menuBottomPartVisible = false;
  }

  createChangePwdForm() {
    this.changePwdForm = this.formBuilder.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
    });
  }

  onChangePasswordClick(event: any) {
    event.preventDefault();
    event.stopPropagation();

    if (this.changePwdForm.invalid) {
      return;
    }
    let changePwdObj = {
      oldPassword: {
        value: this.changePwdForm.get('oldPassword').value,
      },
      newPassword: {
        value: this.changePwdForm.get('newPassword').value,
      },
    };
    // this.changePwdSubscription = this.oktaCustomApiService
    //   .changeOktaUserPassword(this.userLogInDetail.userId, changePwdObj)
    //   .subscribe(
    //     (resp) => {
    //       this.toastService.showSuccessToast(this.constant.changePasswordToast);
    //       this.menuBottomPartVisible = true;
    //       this.changePwdForm.reset();
    //     },
    //     (error) => {
    //       this.toastService.clearAllToast();
    //       this.toastService.showErrorToast(this.constant.oldPasswordToast);
    //       this.changePwdForm.reset();
    //     }
    //   );
  }

  discardChangeLoc(event: any) {
    this.menuBottomPartVisible = true;
    event.preventDefault();
    event.stopPropagation();
    this.changePwdForm.reset();
  }

  checkCashRegisterOrNot(subSubGroupName: string) {
    this.migratingPage = true;
    this.lastUrl = '';

    let cashRegisterData = this.posService.getOption();
    let status = this.posService.getStatusToUpdate();

    if (status == null) status = 'Idle';

    let headingMessage = this.constant.cancelCashRegisterHeadingMessage;
    let subMessage = this.constant.SubMessage;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      height: '23%',
      width: '346px',
      data: { heading: headingMessage, message: subMessage },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (cashRegisterData.refNo)
          if (status === 'CheckedOut' || status === 'Idle')
            this.updateStatusProvisionSub = this.posService
              .updateOrgDetailsStatusToOpen(
                this.apiUrl.updateOrgDetailsStatusToIdle,
                cashRegisterData.refNo,
                status
              )
              .subscribe();

        this.isAndroid =
          this.persistenceService.get('OS') == 'Android' ? true : false;
        this.router.navigateByUrl(
          this.pageurl.getUrl(subSubGroupName, this.isAndroid)
        );
      } else {
        this.migratingPage = false;
        this.lastUrl = 'cashRegister';
      }
    });
  }
  //**************************************FireBase */
  requestPermission() {
    const messaging = getMessaging();
    getToken(messaging, { vapidKey: this.appConfig.setting.firebase.vapId })
      .then((currentToken) => {
        if (currentToken) {
          console.log('we got the token.....');
          console.log(currentToken);

          this.persistenceService.set('FirebaseToken', currentToken);
          if (this.persistenceService.get('userDetail') != undefined) {
            this.fCMMessageRegistration = new FCMMessageRegistration();
            this.fCMMessageRegistration.deviceId =
              this.persistenceService.get('DeviceID');
            this.fCMMessageRegistration.locId = parseInt(
              this.persistenceService.get('locId')
            );
            if (this.persistenceService.get('userId') != undefined)
              this.fCMMessageRegistration.locCusId = this.persistenceService.get('userId');
            else
              this.fCMMessageRegistration.locCusId = this.persistenceService.get('DeviceID');
            this.fCMMessageRegistration.token = currentToken;
            this.fCMMessageRegistration.deviceType = 'Web';
            this.saveFCMTokenData(currentToken);
          }
        } else {
          console.log(
            'No registration token available. Request permission to generate one.'
          );
        }
      })
      .catch((err) => {
        if (this.deviceDetector.getOS() != 'Android')
          this.toastService.showErrorToast("Please enable notification permission");
        console.log('An error occurred while retrieving token. ', err);
      });
  }

  listen() {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      console.log('Message received. ', payload);
      this.fcmResponse = payload;
      this.nos = this.nos + 1;
      if (payload.notification.title == 'Full Data For Monitoring') {
        this.persistenceService.setMonitoringDashboardData(
          'monitoringDashboardData',
          payload.notification.body
        );
        // alert("Full Data For Monitoring");
        return;
      }
      this.toastService.showSuccessToast(this.constant.newNotificationToast);
      console.log('Message received.With Title', payload.notification.title);
      console.log('Message received.With Body', payload.notification.body);

      // Parse the message body into a structured object
      let parsedMessage;
      if (
        this.fcmResponse.notification.title == 'Web Order' ||
        this.fcmResponse.notification.title == 'Order Delivery' ||
        this.fcmResponse.notification.title == 'Customized Product'
      ) {
        parsedMessage = this.parseMessageBody(payload.data?.messageBody);
      } else if (this.fcmResponse.notification.title == 'Cancel Message') {
        parsedMessage = this.parseMessageBodyForCancel(payload.data);
      } else if (this.fcmResponse.notification.title == 'Leave Approved' ||
        this.fcmResponse.notification.title == 'Loan Approved' ||
        this.fcmResponse.notification.title == 'Salary Approved'
      ) {
        parsedMessage = this.parseApproveLeaveLoanSalaryNotification(payload.data);
      }

      console.log('Received Message For Module: ' + parsedMessage.forModule);
      console.log('Received Beep : ' + parsedMessage.beep);
      console.log('Received Message readMessage: ' + parsedMessage.readMessage);
      console.log(
        'Received Message refNo : ' +
        parsedMessage.refNo +
        '=====' +
        this.persistenceService.get('locId')
      );

      // Show small notification
      this.showSmallNotification(payload);

      console.log('NOM=' + this.nos);
      if (this.nos > 0) {
        this.hideMatBadge = false;
      } else {
        this.hideMatBadge = true;
      }
      if (
        this.fcmResponse.notification.title == 'Web Order' ||
        this.fcmResponse.notification.title == 'Order Delivery' ||
        this.fcmResponse.notification.title == 'Customized Product'
      ) {
        this.webOrderRequest(
          parsedMessage.refNo,
          parsedMessage.message,
          parsedMessage.beep,
          parsedMessage.readMessage,
          parsedMessage.forModule
        );
      }
      if (this.fcmResponse.notification.title == 'Cancel Message') {
        let refNo: string = parsedMessage.refNo;
        let forModule: string = parsedMessage.forModule;

        this.cancelMessage(refNo, forModule);
      }
      this.currentMessage.next(payload);
    });
  }

  // Method to parse the message body and return an object with values
  parseMessageBody(data: string) {
    console.log("parse Message Body1 : " + data)
    const messageParts = data.split('===');
    console.log("parse Message Body2 : " + messageParts.length)

    return {
      message: messageParts[0],
      forModule: messageParts[1]?.split(':')[1],
      refNo: messageParts[2]?.split(':')[1],
      readMessage: messageParts[3]?.split(':')[1],
      beep: messageParts[4]?.split(':')[1],
      locId: messageParts[5]?.split(':')[1],
    };
  }

  parseApproveLeaveLoanSalaryNotification(data) {
    return {
      message: data.messageBody,
      forModule: data.forModule,
      refNo: data.refNo,
      readMessage: data.readMessageYesNo,
      beep: data.beepYesNo,
      // locId: ,
    };
  }

  parseMessageBodyForCancel(data: any) {
    // return {
    //   forModule: data[0]?.split(':')[0],
    //   refNo: data[2]?.split(':')[1],
    // }
    return {
      forModule: data.forModule || 'defaultModule', // Fallback if forModule doesn't exist
      refNo: data.refNo || 'defaultRefNo', // Fallback if refNo doesn't exist
    };
  }

  showSmallNotification(payload: any) {
    // Extract title
    const notificationTitle = payload.notification?.title || 'Notification';

    let messageBody = payload.data?.messageBody || 'New message received'; // Directly use messageBody

    console.log('Raw messageBody:', messageBody);

    // Extract the first part of messageBody before "==="
    const cleanMessageBody = messageBody.split('===')[0]?.trim();
    console.log('Clean MessageBody:', cleanMessageBody);

    // Convert messageBody to user-friendly text
    let userFriendlyMessage =
      this.extractAndHandleMessageBodyNotification(cleanMessageBody);

    if (cleanMessageBody === "Leave Approval" || cleanMessageBody === "Loan Approval" ||
      cleanMessageBody === "Salary Approval"
    )
      userFriendlyMessage = messageBody.split('===')[1]?.trim()

    // Final Notification Message
    console.log(`Notification: ${notificationTitle} - ${userFriendlyMessage}`);

    // Show Browser Notification (if allowed)
    if (Notification.permission === 'granted') {
      new Notification(notificationTitle, { body: userFriendlyMessage });
    }
  }

  extractAndHandleMessageBodyNotification(messageBody: string): string {
    let headingMessage: string;

    switch (messageBody.trim()) {
      case 'Web Order Placed':
        headingMessage = 'New order received, accept now to start processing.';
        break;
      case 'Web Order Accepted':
        headingMessage = 'New web order accepted, now ready for processing.';
        break;
      case 'Delivery pending1, Assign to any rider':
        headingMessage =
          'Reminder, your order delivery is in 2 hours. Please prepare your order for pickup to avoid delays.';
        break;
      case 'Delivery pending2, Assign to any rider':
        headingMessage = '60-minute delay warning. Prepare your order quickly for pickup to avoid delays.';
        break;
      case 'Delivery pending3, Assign to any rider':
        headingMessage = 'Critical delay warning. Only 30 minutes left to deliver your order.';
        break;
      case 'Customized Order':
        headingMessage =
          'New customized order requested, please accept to start processing.';
        break;
      case 'Customized Order Accepted':
        headingMessage =
          'Customized order accepted, now ready for processing.';
        break;
      case 'Web Order Rescheduled':
        headingMessage =
          'Web order has been rescheduled. Please check the updated details.';
        break;
      case 'Web Order Cancelled':
        headingMessage =
          'Web order has been cancelled. Please review the cancellation details.';
        break;
      default:
        headingMessage = this.constant.parkSubMessage; // Default message
    }

    console.log('Final Heading Message:', headingMessage);
    return headingMessage;
  }

  ngOnDestroy() {
    if (this.moduleSubscription !== undefined)
      this.moduleSubscription.unsubscribe();
    if (this.subModuleSubscription !== undefined)
      this.subModuleSubscription.unsubscribe();
    if (this.subSubModuleSubscription !== undefined)
      this.subSubModuleSubscription.unsubscribe();
    if (this.getUserProfileSubscription !== undefined)
      this.getUserProfileSubscription.unsubscribe();
    if (this.changePwdSubscription !== undefined)
      this.changePwdSubscription.unsubscribe();

    if (this.insertErrorLogSubscription !== undefined)
      this.insertErrorLogSubscription.unsubscribe();
    if (this.initialDataSubscription !== undefined)
      this.initialDataSubscription.unsubscribe();
    if (this.initInterval) {
      clearInterval(this.initInterval);
    }
    if (this.createSubscription !== undefined) {
      this.createSubscription.unsubscribe();
    }
  }

  public scanSuccessHandler($event: any) {
    this.scannerEnabled = false;
  }

  public enableScanner() {
    this.scannerEnabled = !this.scannerEnabled;
    this.information = 'Enable Scanner';
  }

  startQRScanner(): any {
    //Use for Web QRCode Scan

    // let dialogRef = this.dialog.open(ScanQRCodeDialogComponent, {
    //   maxWidth: '90%',
    //   width: '90%',
    //   height: '515px',
    //   data: { selectedCustomer: this.selectedCustomer }
    // });
    // dialogRef.afterClosed().subscribe(res => {

    // })

    //use for mobile QRCode Scan
    //nms is the id of the textbox/other tags whose value will be set
    qrCodeData('nms');
  }

  clearResult(): void {
    this.qrResultString = null;
  }

  onCodeResult(resultString: string) {
    this.qrResultString = resultString;
  }

  @HostListener('window:unload', ['$event'])
  beforeUnloadHanderpage($event) { }

  @HostListener('window:beforeunload', ['$event']) unloadHandler(event: Event) {
    this.checkCashRegisterOrNot(this.subSubGroupName);
    return;
  }
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event: any) {
    //return false;
  }

  @HostBinding('attr.autocomplete') autocomplete = 'off';

  //mat-form-field-autofill-control

  index = 1;
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    this.allowPageNavigation = false;
    if (event.key == 'ArrowDown') {
      const target = event.target as HTMLButtonElement;
      if (target.className.includes('mat-autocomplete')) {
        const newtargetId = 'mat-autocomplete-0';

        if (document.getElementById(newtargetId)) {
          document.getElementById(newtargetId).scrollTop = this.index * 45;
          if (document.getElementById(newtargetId).children.length > this.index)
            this.index++;
        }
      } else if (target.id.includes('mat-input-')) {
        event.preventDefault();
        const targetId =
          'mat-input-' + (Number(target.id.replace('mat-input-', '')) + 1);
        if (document.getElementById(targetId))
          document.getElementById(targetId).focus();
      }
    } else if (event.key == 'ArrowUp') {
      const target = event.target as HTMLButtonElement;
      if (target.className.includes('mat-autocomplete')) {
        const newtargetId = 'mat-autocomplete-0';
        if (document.getElementById(newtargetId)) {
          if (this.index > 1) this.index--;
          document.getElementById(newtargetId).scrollTop = this.index * 45;
        }
      } else if (target.id.includes('mat-input-')) {
        event.preventDefault();
        const targetId =
          'mat-input-' + (Number(target.id.replace('mat-input-', '')) - 1);

        if (document.getElementById(targetId))
          document.getElementById(targetId).focus();
      }
    } else {
      const value = (event.target as HTMLInputElement).value;
      this.allowPageNavigation = false;
    }
  }

  @HostListener('dragover', ['$event'])
  onDragOver(ev: DragEvent) {
    //this.saveLastActivityTimeOfUser();
    ev.preventDefault();
    ev.stopPropagation();
    return;
  }

  @HostListener('document:dblclick', ['$event'])
  onDblClick(event: MouseEvent): void {
    // console.log('DblClick');
    // this.saveLastActivityTimeOfUser();
    event.preventDefault();
    event.stopPropagation();
    return;
  }

  @HostListener('document:contextmenu', ['$event'])
  onContextMenu(event: MouseEvent) {
    // console.log('ContextMenu');
    // this.saveLastActivityTimeOfUser();
    event.preventDefault();
  }

  @HostListener('document:mousedown', ['$event'])
  onMouseDown(event) {
    // console.log('mousedown1');
    // this.saveLastActivityTimeOfUser();
    // console.log("Dddd" + event)
    // we make sure only draggables on the document elements are selected
    if (event.target.getAttribute('draggable')) {
      console.log('mousedown2');

      // ##### add this code.
      //event.preventDefault();    // choose one
      // ##### or add this code.
      return false; // choose one
    }
  }
  @HostListener('wheel', ['$event'])
  onMouseWheel(event) {
    // console.log('mouseOver');
    // this.saveLastActivityTimeOfUser();
    let s: string = event.target.getAttribute('type');
    if (s != null) {
      if (s.includes('number')) return false;
    }
  }

  @HostListener('click', ['$event.target']) onClick(e) {
    // if (e.className.includes("ng-tns")) {
    //   console.log("Clicked" + e.className)
    //   const btn = document.getElementById(e.id) as HTMLButtonElement | null;
    //   btn?.setAttribute('disabled', 'true')
    //   setTimeout(() => btn?.setAttribute('disabled', 'true'), 50);
    //   setTimeout(() => btn?.removeAttribute('disabled'), 3000);
    // }
  }
  // saveLastActivityTimeOfUser()
  // {
  //   let d2: Date = new Date();
  //   this.persistenceService.set("lastActivityTime",d2.toString())
  // }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////Handling FCM Messages////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  cancelMessage(refNo: string, forModule: string) {
    this.tempData = '';
    this.manageBeepAndTextList = this.persistenceService.get(
      'manageBeepAndTextList'
    );
    if (this.manageBeepAndTextList != null) {
      if (this.manageBeepAndTextList.length > 0) {
        let mainData: string[] = this.manageBeepAndTextList.split(';;;;;');
        for (let i = 0; i < mainData.length; i++) {
          let eachData: string[] = mainData[i].split('=====');
          if (eachData.length > 2) {
            if (forModule == eachData[4] && refNo == eachData[0]) {
              console.log('Cancel message' + eachData[4]);
            } else {
              if (this.tempData.length > 0) {
                this.tempData +=
                  ';;;;;' +
                  eachData[0] +
                  '=====' +
                  eachData[1] +
                  '=====' +
                  eachData[2] +
                  '=====' +
                  eachData[3] +
                  '=====' +
                  eachData[4];
              } else {
                this.tempData =
                  eachData[0] +
                  '=====' +
                  eachData[1] +
                  '=====' +
                  eachData[2] +
                  '=====' +
                  eachData[3] +
                  '=====' +
                  eachData[4];
              }
            }
          }
        }
      }
      this.manageBeepAndTextList = this.tempData;
      console.log('After Cancel==' + this.tempData);
      // this.persistenceService.set(
      //   'manageBeepAndTextList',
      //   this.manageBeepAndTextList
      // );
      this.dialogRefWeb.close();
      this.confirmDialogOpen = false;
      this.isPlaying = false;
      this.persistenceService.set('manageBeepAndTextList', '');
      StopPlayingMusic();
      console.log(this.confirmDialogOpen)
      console.log(this.isPlaying)
    }
  }
  dialogRefWeb: any;
  webOrderRequest(refNo: string, message: string, beep: string, readMessage: string, forModule: string): void {
    if (this.manageBeepAndTextList?.length == 0) this.confirmDialogOpen = false;
    if (this.manageBeepAndTextList != null) {
      if (this.manageBeepAndTextList.length > 0) {
        let mainData: string[] = this.manageBeepAndTextList.split(';;;;;');
        for (let i = 0; i < mainData.length; i++) {
          let eachData: string[] = mainData[i].split('=====');
          if (eachData.length > 2) {
            if (forModule == eachData[4] && refNo == eachData[0]) {
              console.log('Same Order Again');
              // return;
            }
          }
        }
      }
      if (this.manageBeepAndTextList.length > 0) {
        this.manageBeepAndTextList += ';;;;;' + refNo + '=====' + message + '=====' + beep + '=====' + readMessage + '=====' + forModule;
      } else {
        this.manageBeepAndTextList = refNo + '=====' + message + '=====' + beep + '=====' + readMessage + '=====' + forModule;
      }
    } else {
      this.manageBeepAndTextList = refNo + '=====' + message + '=====' + beep + '=====' + readMessage + '=====' + forModule;
    }
    console.log('List While Adding  ' + this.manageBeepAndTextList);
    this.persistenceService.set('manageBeepAndTextList', this.manageBeepAndTextList);

    if (this.deviceDetector.getOS() != 'Android')
      this.runContiniously();

    let headingMessage = this.extractAndHandleMessageBody();
    let subMessage = this.constant.parkSubMessage;
    console.log('Heading Message:', headingMessage);
    if (!this.confirmDialogOpen) {
      this.confirmDialogOpen = true;
      this.dialogRefWeb = this.dialog.open(ConfirmationDialogComponent, {
        height: 'auto',
        width: '346px',
        data: { heading: headingMessage, message: subMessage },
      });

      this.dialogRefWeb.afterClosed().subscribe((result) => {
        console.log(result);
        this.confirmDialogOpen = false;
        this.isPlaying = false;
        this.persistenceService.set('manageBeepAndTextList', '');
        StopPlayingMusic();

        if (result) {
          if (this.router.url.toString().includes('okta-login'))
            this.toastService.showWarningToast('Please login & Check the shipping');
          else {
            if (forModule == 'Web Order') {
              if (this.router.url.toString().includes(this.constant.URL_WEB_ORDER_CONFIRMATION))
                window.location.reload();
              else
                window.location.href = window.location.origin + '/' + this.constant.URL_WEB_ORDER_CONFIRMATION;
            } else if (forModule == 'Customized Product') {
              if (this.router.url.toString().includes(this.constant.URL_CUSTOMIZE_ORDER))
                window.location.reload();
              else
                window.location.href = window.location.origin + '/' + this.constant.URL_CUSTOMIZE_ORDER;
            } else if (forModule == 'Web Order Assign') {
              if (this.router.url.toString().includes(this.constant.ORDER_DELIVERY))
                window.location.reload();
              else
                window.location.href = window.location.origin + '/' + this.constant.ORDER_DELIVERY;
            } else if (forModule == 'Web Order Rescheduled') {
              if (this.router.url.toString().includes(this.constant.URL_WEB_ORDER))
                window.location.reload();
              else
                window.location.href = window.location.origin + '/' + this.constant.URL_WEB_ORDER;
            } else if (forModule == 'Web Order Cancelled') {
              if (this.router.url.toString().includes(this.constant.URL_WEB_ORDER_REFUND))
                window.location.reload();
              else
                window.location.href = window.location.origin + '/' + this.constant.URL_WEB_ORDER_REFUND;
            }
          }
        }
      });
    }
  }

  extractAndHandleMessageBody(): string {
    let mainData: string[] = this.manageBeepAndTextList.split(';;;;;');
    let headingMessages: string[] = [];

    for (let i = 0; i < mainData.length; i++) {
      let eachData: string[] = mainData[i].split('=====');

      // Ensure correct data indexing and check conditions
      if (eachData.length > 3 && eachData[2]?.trim() === 'Yes') {
        let messageBody = eachData[1]?.trim() || ''; // Extract correct segment (2nd part)
        console.log("Extracted messageBody:", messageBody);

        // Select correct heading message based on `messageBody`
        let headingMessage;
        switch (messageBody) {
          case "Web Order Placed":
            headingMessage = "New order received, accept now to start processing.";
            break;
          case "Web Order Accepted":
            headingMessage = "New web order accepted, now ready for processing.";
            break;
          case "Delivery pending1, Assign to any rider":
            headingMessage = "Reminder, your order delivery is in 2 hours. Please prepare your order for pickup to avoid delays.";
            break;
          case "Delivery pending2, Assign to any rider":
            headingMessage = "60-minute delay warning. Prepare your order quickly for pickup to avoid delays.";
            break;
          case "Delivery pending3, Assign to any rider":
            headingMessage = "Critical delay warning. Only 30 minutes left to deliver your order.";
            break;
          case 'Customized Order':
            headingMessage =
              'New customized order requested, please accept to start processing.';
            break;
          case 'Customized Order Accepted':
            headingMessage =
              'Customized order accepted, now ready for processing.';
            break;
          case 'Web Order Rescheduled':
            headingMessage =
              'Web order has been rescheduled. Please check the updated details.';
            break;
          case 'Web Order Cancelled':
            headingMessage =
              'Web order has been cancelled. Please review the cancellation details.';
            break;
          default:
            headingMessage = this.constant.parkSubMessage; // Default fallback
        }
        headingMessages.push(headingMessage);
      }
    }

    // Return all extracted messages (if any)
    const finalMessage = headingMessages.length > 0 ? headingMessages.join(" | ") : this.constant.parkSubMessage;
    console.log("Final Heading Message:", finalMessage);
    return finalMessage;
  }


  runContiniously() {
    console.log('Run Continiously', this.manageBeepAndTextList);
    console.log('Run Continiously1', this.message);
    let fullMess = '';
    let cntMessagesReadAndBeep = 0;
    this.intervalId = setInterval(() => {
      this.message = '';
      let beep = 'No';
      this.manageBeepAndTextList = this.persistenceService.get(
        'manageBeepAndTextList'
      );

      if (this.manageBeepAndTextList != null) {
        if (this.manageBeepAndTextList.length > 0) {
          if (fullMess && fullMess.toString() == this.manageBeepAndTextList)
            cntMessagesReadAndBeep++;
          if (cntMessagesReadAndBeep > 10) {
            this.persistenceService.set('manageBeepAndTextList', '');
            this.manageBeepAndTextList = null;
            fullMess = '';
            cntMessagesReadAndBeep = 0;
          }
          fullMess = this.manageBeepAndTextList;
        }
      }

      if (this.manageBeepAndTextList != null) {
        if (this.manageBeepAndTextList.length > 0) {
          let mainData: string[] = this.manageBeepAndTextList.split(';;;;;');
          let extractedMessages: string[] = [];

          for (let i = 0; i < mainData.length; i++) {
            let eachData: string[] = mainData[i].split('=====');
            if (eachData.length > 2) {
              if (eachData[2] == 'Yes') {
                beep = 'Yes';
              }
              if (eachData[3] == 'Yes') {
                extractedMessages.push(eachData[1].trim()); // Keep the full message
              }
            }
          }

          // Use a `|` separator to keep messages intact
          this.message = extractedMessages.join(' | ');

          console.log('Message Total1:', this.message);
        }

      }
      if (beep == 'Yes') {
        // this.beep();
      }
      if (this.message.length > 0) {
        console.log('Message Total2', this.message);
        this.textToSpeech(this.message);
      }
    }, 15 * 1000);
  }

  beep() {
    var context = new AudioContext();
    var oscillator = context.createOscillator();
    oscillator.type = 'sine';
    oscillator.frequency.value = 800;
    oscillator.connect(context.destination);
    oscillator.start();
    setTimeout(function () {
      oscillator.stop();
    }, 100);
  }

  textToSpeech(txt: string) {
    if (this.deviceDetector.getOS() == 'Android') {
      console.log('Message Total3' + this.message);
      textToSpeechAnd(txt);
      // const parsedMessage = this.parseMessageBody(txt);
      // this.webOrderRequest(parsedMessage.refNo, parsedMessage.message, parsedMessage.beep, parsedMessage.readMessage, parsedMessage.forModule);
    } else {
      // if ('speechSynthesis' in window) {
      //   let msg = new SpeechSynthesisUtterance();
      //   msg.voice = speechSynthesis.getVoices()[0];
      //   msg.lang = 'en';
      //   msg.rate = 1;
      //   msg.volume = 1;
      //   msg.pitch = 0.5;
      //   msg.text = txt;
      //   speechSynthesis.speak(msg);
      // }
      this.playBeepAndAudio(txt);
    }
  }

  private isPlaying = false;
  private messageQueue: string[] = [];
  async playBeepAndAudio(inputString: string) {
    if (!inputString || typeof inputString !== 'string') {
      console.error("Received invalid inputString:", inputString);
      return;
    }

    console.log("Received Input:", inputString);

    // Split messages by `|` and trim spaces
    const messages = inputString.split('|').map(msg => msg.trim());

    // **Avoid duplicate messages**
    messages.forEach(msg => {
      if (!this.messageQueue.includes(msg)) {
        this.messageQueue.push(msg);
      }
    });

    console.log("MessageQueue:", this.messageQueue, "IsPlaying=>", this.isPlaying);

    // Start processing only if not already playing
    if (!this.isPlaying) {
      this.isPlaying = true;
      try {
        await this.processQueue();
      } catch (error) {
        console.error("Error processing queue:", error);
      } finally {
        this.isPlaying = false;
      }
    }
  }

  private async processQueue() {
    while (this.messageQueue.length > 0) {
      const messageBody = this.messageQueue.shift(); // Get first message
      if (!messageBody) continue;

      try {
        console.log("Processing message:", messageBody);

        await this.ensureUserInteraction();
        await this.playBeepFile(messageBody);
        await this.playAudioFile(messageBody);
      } catch (error) {
        console.error("Error during playback:", error);
      }
    }

    // **Mark as not playing after queue is fully processed**
    this.isPlaying = false;
  }


  // Ensures user interacts with the page before playing sounds
  private async ensureUserInteraction(): Promise<void> {
    return new Promise((resolve) => {
      if (document.visibilityState === "visible") {
        resolve();
      } else {
        console.warn("Waiting for user interaction before playing sound...");
        document.addEventListener("click", () => resolve(), { once: true });
      }
    });
  }

  // Function to play different beep sounds based on `messageBody`
  playBeepFile(messageBody: string): Promise<void> {
    return new Promise((resolve) => {
      let beep = new Audio();

      // Select different beep files based on `messageBody`
      switch (messageBody) {
        case 'Web Order Placed':
        case 'Web Order Accepted':
          beep.src = 'assets/sound/Weborder Accepted beep.mp3';
          break;
        case 'Delivery pending1, Assign to any rider':
          beep.src = 'assets/sound/Your order delivery is in 2 hours beep.mp3';
          break;
        case 'Delivery pending2, Assign to any rider':
          beep.src = 'assets/sound/60 minute Delay beep.mp3';
          break;
        case 'Delivery pending3, Assign to any rider':
          beep.src = 'assets/sound/Only 30-minutes beep.mp3';
          break;
        default:
          beep.src = 'assets/sound/announcement.mp3'; // Default beep
      }

      console.log("Playing Beep for:", messageBody, "->", beep.src);
      beep.load();
      beep.play().then(() => {
        console.log("Beep Started for:", messageBody);
      }).catch(error => {
        console.error("Beep play failed:", error);
        resolve(); // Continue execution even if the beep fails
      });

      // Resolve when beep finishes
      beep.onended = () => {
        console.log('Beep Finished for:', messageBody);
        resolve();
      };
    });
  }

  // Function to play different audio messages
  playAudioFile(messageBody: string): Promise<void> {
    return new Promise((resolve) => {
      let audio = new Audio();

      // Select correct audio file based on `messageBody`
      switch (messageBody) {
        case 'Web Order Placed':
          audio.src =
            'assets/sound/Weborder Received Accept to Process Further.mp3';
          break;
        case 'Web Order Accepted':
          audio.src = 'assets/sound/Weborder Accepted.mp3';
          break;
        case 'Delivery pending1, Assign to any rider':
          audio.src = 'assets/sound/Your order delivery is in 2 hours.mp3';
          break;
        case 'Delivery pending2, Assign to any rider':
          audio.src = 'assets/sound/60 minute Delay Warning.mp3';
          break;
        case 'Delivery pending3, Assign to any rider':
          audio.src =
            'assets/sound/Only 30-minutes left to deliver your Order.mp3';
          break;
        default:
          audio.src = 'assets/sound/announcement.mp3'; // Default fallback
      }

      console.log("Playing Audio for:", messageBody, "->", audio.src);
      audio.load();
      audio.play().then(() => {
        console.log("Audio Started for:", messageBody);
      }).catch(error => {
        console.error("Audio play failed:", error);
        resolve(); // Continue execution even if the audio fails
      });

      // Resolve when audio finishes
      audio.onended = () => {
        console.log('Finished Audio for:', messageBody);
        resolve();
      };
    });
  }

  encryptFun(data) {
    if (data.length > 9 || data.length < 5) return;
    var sum = 0;
    var newData = '';
    var newDataFinal = '';
    var sumz = '';
    const date = new Date();
    const day = this.datePipe.transform(date, 'dd');
    let ascV = 0;
    for (var i = 0; i < data.length; i++) {
      switch (Number(data.charAt(i))) {
        case 0:
          ascV = 59;
          break;
        case 1:
          ascV = 62;
          break;
        case 2:
          ascV = 35;
          break;
        case 3:
          ascV = 78;
          break;
        case 4:
          ascV = 67;
          break;
        case 5:
          ascV = 71;
          break;
        case 6:
          ascV = 46;
          break;
        case 7:
          ascV = 29;
          break;
        case 8:
          ascV = 53;
          break;
        default:
          ascV = 92;
          break;
      }
      sum += ascV;
      newData += ascV.toString();
    }
    sum += Number(day);
    for (var i = 0; i < newData.length; i++) {
      newDataFinal += newData.toString().charAt(i);
      if (i == 2) newDataFinal += sum.toString().charAt(0);
      if (i == 5) newDataFinal += sum.toString().charAt(1);
      if (i == 8) newDataFinal += sum.toString().charAt(2);
    }

    newDataFinal = sum.toString() + newDataFinal + data.length.toString();

    //alert(sum + '===' + data + '===' + newData + '===' + newDataFinal);
  }

  enableDisableMonitoring(url) {
    if (url.includes('monitoring-dashboard'))
      this.enableDisableFCMMonitoring = 'Yes';
    else this.enableDisableFCMMonitoring = 'No';
    if (
      this.enableDisableFCMMonitoring != this.enableDisableFCMMonitoringLastUsed
    ) {
      if (!window.location.href.includes('okta-login')) {
        this.commonService
          .enableDisableFCMForUserWhenMonitoring(
            this.apiUrl.enableDisableFCMForUserWhenMonitoring,
            this.enableDisableFCMMonitoring
          )
          .subscribe(async (response: any) => { });
      }
    }
    this.enableDisableFCMMonitoringLastUsed = this.enableDisableFCMMonitoring;
  }

  runShellCommand() {
    var childProcess = require('child_process');
    console.log(childProcess);
    // terminal.stdout.on('data', function (data) {
    //   console.log('stdout: ' + data);
    // });

    // terminal.on('exit', function (code) {
    //   console.log('child process exited with code ' + code);
    // });
  }

  onThemeChange(theme: string, isIntialSetupCall) {
    this.selectedTheme = theme;
    if (theme === 'default') {
      this.themeService.setDarkTheme(false);
      this.themeService.clearUserThemeVariables();
      this.isDarkTheme = false;
    } else if (theme === 'dark') {
      this.themeService.setDarkTheme(true);
      console.log("DARK THEME CALLED");
      this.isDarkTheme = true;
    } else if (theme === 'user') {
      this.themeService.setDarkTheme(false);
      // const savedTheme = this.persistenceService.get('appThemeConfig');
      const savedTheme = this.existingInternationalizationSetup
      if (savedTheme) {
        // this.themeService.applyusertheme(JSON.parse(savedTheme));
        this.themeService.applyusertheme(savedTheme);

      }
      this.isDarkTheme = false;
    }
    if (!isIntialSetupCall) {
      this.existingInternationalizationSetup.theme = theme;
      this.existingInternationalizationSetup.fromLocationCode = JSON.parse(this.persistenceService.get('locId'));
      if (this.existingInternationalizationSetup.language == null || this.existingInternationalizationSetup.language == undefined) {
        this.existingInternationalizationSetup.language = "en"
      }
      this.createSubscription = this.masterFunctionService.insertInternationalization(
        this.apiUrl.InsertInternationalizationInitialData, "theme",
        this.existingInternationalizationSetup,
      ).subscribe((data) => {
        if (data) {
          console.log("Internationalization configuration created successfully for the selected theme.")
        }
      })
    }
  }

  toggleTheme() {
    this.themeService.toggleTheme();
    this.isDarkTheme = document.body.classList.contains('dark-theme');
  }

  getAllowedFinancialYear() {
    this.commonService.getAllowedFinancialYear(this.apiUrl.getAllowedFinancialYearAndNoOfDays).subscribe((fy: any) => {
      console.log('FY from API:', fy)
      this.commonService.setAllowedFinancialYear(fy.data.allowedFinancialYear);
      this.persistenceService.set('noOfDaysAllowed', fy.data.noOfDays);
    });
  }

  getPendingWebOrders() {
    if (window.location.pathname.includes('login')) {
      console.log('⏳ Login required — web order check skipped.');
      return;
    }
    let viewWebOrder: RequestView = new RequestView();
    viewWebOrder.userId = this.persistenceService.get('userId');

    this.onViewSetUpSubscription = this.webOrderService.onViewSetUp(this.apiUrl.getWebOrderDetailsByUser, viewWebOrder).subscribe((data: any) => {
      if (data && data.length > 0) {
        const sheetRef = this.bottomSheet.open(PendingOrdersBottomSheetComponent,
          {
            disableClose: true,
            panelClass: 'pending-orders-sheet',
            data: { count: data.length }
          }
        );

        sheetRef.afterDismissed().subscribe(result => {
          if (result) {
            this.router.navigate([this.constant.URL_WEB_ORDER_CONFIRMATION]);
          }
        });
      }
    }, (error: HttpErrorResponse) => {
      this.insertErrorLog("getPendingWebOrders", error);
    });
  }

  showTranslate = false;
  languages = [
    { code: 'en', name: 'English' },
    { code: 'hi', name: 'हिंदी' },
  ];
  selectedLang: string = 'en';
  changeLanguage(langCode: string, isIntialSetupCall): void {
    if (this.selectedLang == langCode) {
      return;
    }
    this.selectedLang = langCode;
    if (!isIntialSetupCall) {
      this.existingInternationalizationSetup.language = langCode;
      this.existingInternationalizationSetup.fromLocationCode = JSON.parse(this.persistenceService.get('locId'))
      this.createSubscription = this.masterFunctionService.insertInternationalization(
        this.apiUrl.InsertInternationalizationInitialData, "language",
        this.existingInternationalizationSetup
      ).subscribe((data) => {
        if (data) {
          console.log("Internationalization configuration created successfully for the selected language.")
        }
      })
    }
    // Run OUTSIDE Angular Zone to prevent thread locks during DOM restoration
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const win = window as any;

        if (langCode === 'en') {
          console.log('[Language Service] Restoring page to original English...');

          // 1. Clear Google Translate cookies
          this.clearCookies();

          // 2. Try Google Translate JS instance restore if available
          let restored = false;
          if (win.googleTranslator) {
            Object.keys(win.googleTranslator).forEach((key) => {
              if (!restored && typeof win.googleTranslator[key]?.restore === 'function') {
                try {
                  win.googleTranslator[key].restore();
                  restored = true;
                  console.log(`[Language Service] Restored via win.googleTranslator.${key}.restore()`);
                } catch (e) {
                  console.warn('[Language Service] Internal restore failed:', e);
                }
              }
            });
          }

          // 3. Fallback: Click hidden iframe restore button
          if (!restored) {
            this.clickHiddenRestoreButton();
          }

          // 4. Trigger combo reset
          const combo = document.querySelector('.goog-te-combo') as HTMLSelectElement;
          if (combo) {
            // Google Translate expects '' or 'en' to restore original text
            combo.value = '';

            window.requestAnimationFrame(() => {
              combo.dispatchEvent(new Event('change', { bubbles: true }));
            });
          }

          // 5. Clean up root element layout classes
          document.documentElement.classList.remove('translated-ltr', 'translated-rtl');
          console.log('[Language Service] Successfully restored to original language without reload.');

        } else {
          // --- SWITCHING TO TARGET LANGUAGE (e.g. 'hi') --- //
          console.log(`[Language Service] Switching language to: "${langCode}"`);
          const combo = document.querySelector('.goog-te-combo') as HTMLSelectElement;

          if (combo) {
            combo.value = langCode;

            window.requestAnimationFrame(() => {
              combo.dispatchEvent(new Event('input', { bubbles: true }));
              combo.dispatchEvent(new Event('change', { bubbles: true }));
            });
          } else {
            console.warn('[Language Service] .goog-te-combo element was not found in DOM.');
          }
        }
      }, 100);
    });
  }

  private clickHiddenRestoreButton(): void {
    try {
      const iframe = (document.querySelector('.goog-te-banner-frame') ||
        document.getElementById(':1.container')) as HTMLIFrameElement;

      if (iframe) {
        const innerDoc = iframe.contentDocument || iframe.contentWindow?.document;
        if (innerDoc) {
          const restoreButtons = innerDoc.querySelectorAll('button');
          restoreButtons.forEach((btn: HTMLElement) => {
            if (btn.id && btn.id.indexOf('restore') >= 0) {
              btn.click();
              console.log('[Language Service] Clicked restore button in banner frame.');
            }
          });
        }
      }
    } catch (e) {
      console.warn('[Language Service] Could not access Google Translate restore iframe:', e);
    }
  }

  private clearCookies(): void {
    const domain = window.location.hostname;
    document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
    document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${domain};`;
  }
}
